module.exports = __webpack_public_path__ + "static/media/p2_16.f851be5e.png";